const { PRODUCT_KEYS } = require("../products");

// ADD THOSE PRODUCTS WHICH ARE APPLICABLE FOR BMI
const BmiIndex = {
  [PRODUCT_KEYS.PNG]: {
    min: 17,
    max: 38,
  },
};

export default BmiIndex;
